import { useSelector } from "react-redux";

export default function useSelectedDetails() {
  return useSelector((state) => state.layout.selectedDetails);
}

